import React from "react";

import {
  Addresses,
  ClientComment,
  ExtraItems,
  Items,
  CompanyNotes,
} from "./components";
function RequestInformation(props) {
  const { fetchRequestDetails, requestData } = props;
  let {
    request_address,
    extra_request_items,
    request_item,
    request,
    request_customer,
  } = requestData;
  const { final_comment, company_notes } = requestData.request;

  extra_request_items = extra_request_items.filter(
    (item) => item.quantity > "0"
  );
  return (
    <>
      <div className="rounded-box">
        <div className="heading-wrapper black-bg text-center position-relative">
          <h6 className="text-white">Request Information</h6>
        </div>
        <Addresses
          request_customer={request_customer}
          request_address={request_address}
          request={request}
          fetchRequestDetails={fetchRequestDetails}
          requestData={requestData}
        />
        <div className="items-info-wrapper mt-2">
          <div className="info-header text-center">
            <h6 className="black-color">Items({request_item.length})</h6>
          </div>
          <Items request_item={request_item} request={request} />
        </div>
        <div className="items-info-wrapper mt-2">
          <div className="info-header text-center">
            <h6 className="black-color">
              Extra Items({extra_request_items.length})
            </h6>
          </div>
          <ExtraItems
            extra_request_items={extra_request_items}
            request={request}
          />
        </div>
        <div className="items-info-wrapper mt-2">
          <div className="info-header text-center">
            <h6 className="black-color">Client Comment</h6>
          </div>
          <ClientComment final_comment={final_comment} />
        </div>
        <div className="items-info-wrapper mt-2">
          <div className="info-header text-center">
            <h6 className="black-color">Company Notes</h6>
          </div>
          <CompanyNotes
            request={request}
            final_comment={company_notes}
            fetchRequestDetails={fetchRequestDetails}
          />
        </div>
      </div>
    </>
  );
}

export default RequestInformation;
